"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _RemoveApiKeyModal = _interopRequireDefault(require("./RemoveApiKeyModal"));
var _apiKeyActions = require("../../../redux/actions/apiKeyActions");
var _modalDecorator = _interopRequireDefault(require("../../../hocs/modalDecorator"));
var _modalActions = require("../../../redux/actions/modalActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapDispatchToProps = {
  removeApiKey: _apiKeyActions.removeApiKey
};
var container = (0, _reactRedux.connect)(null, mapDispatchToProps)(_RemoveApiKeyModal["default"]);
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.REMOVE_API_KEY
})(container);